import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/** Funzionalità mostrata nella griglia della pagina About */
interface AboutFeature {
  icon: string;
  titleKey: string;
  descriptionKey: string;
}

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css'
})
export class AboutComponent {
  /** Funzionalità della piattaforma (le chiavi sono già presenti in i18n) */
  readonly features: AboutFeature[] = [
    { icon: 'fa-boxes-packing', titleKey: 'ABOUT_PAGE.FEATURE_SHIPMENTS_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_SHIPMENTS_DESC' },
    { icon: 'fa-box', titleKey: 'ABOUT_PAGE.FEATURE_TRACKING_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_TRACKING_DESC' },
    { icon: 'fa-undo-alt', titleKey: 'ABOUT_PAGE.FEATURE_RETURNS_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_RETURNS_DESC' },
    { icon: 'fa-chart-bar', titleKey: 'ABOUT_PAGE.FEATURE_ANALYTICS_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_ANALYTICS_DESC' },
    { icon: 'fa-lock', titleKey: 'ABOUT_PAGE.FEATURE_SECURITY_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_SECURITY_DESC' },
    { icon: 'fa-bolt', titleKey: 'ABOUT_PAGE.FEATURE_PERFORMANCE_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_PERFORMANCE_DESC' },
    { icon: 'fa-globe', titleKey: 'ABOUT_PAGE.FEATURE_MULTILANG_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_MULTILANG_DESC' },
    { icon: 'fa-mobile-alt', titleKey: 'ABOUT_PAGE.FEATURE_RESPONSIVE_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_RESPONSIVE_DESC' },
    { icon: 'fa-tools', titleKey: 'ABOUT_PAGE.FEATURE_INTEGRATION_TITLE', descriptionKey: 'ABOUT_PAGE.FEATURE_INTEGRATION_DESC' }
  ];
}
